
import React from 'react';
import { IndianRupee, ShieldCheck, CheckCircle, Info } from 'lucide-react';

const PricingPage: React.FC = () => {
  return (
    <div className="pb-24">
      {/* PM Suryaghar Pricing Focus */}
      <section className="bg-green-900 py-24 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-black mb-6 uppercase tracking-tight">PM Surya Ghar Rates</h1>
          <p className="text-green-100 opacity-80 max-w-2xl mx-auto text-lg">
            Nationalize bank financing at 6-7% simple interest. Start saving from Day 1.
          </p>
        </div>
      </section>

      {/* Main Pricing Tables */}
      <section className="py-24 container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Residential Rooftop */}
          <div className="bg-white p-12 rounded-[3.5rem] shadow-2xl border border-slate-100">
            <h3 className="text-2xl font-black mb-8 uppercase tracking-widest text-slate-400 flex items-center gap-3">
               <ShieldCheck className="text-green-600" /> Residential Rooftop
            </h3>
            <div className="space-y-8">
              {[
                { label: '1kW to 3kW System', price: '₹65,000 - ₹1.95L', desc: 'Max Subsidy: ₹78k' },
                { label: '4kW to 10kW System', price: '₹2.6L - ₹6.5L', desc: 'BESCOM Net-Metering incl.' },
                { label: 'Bank Interest', price: '6-7% APR', desc: 'Unsecured Loans (120 Mo)' },
              ].map((item, i) => (
                <div key={i} className="flex justify-between items-center border-b border-slate-50 pb-6 last:border-0">
                  <div>
                    <div className="font-black text-slate-900 text-lg">{item.label}</div>
                    <div className="text-xs text-slate-400 font-bold uppercase tracking-widest mt-1">{item.desc}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-2xl font-black text-green-700">{item.price}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Pumps & Lighting */}
          <div className="bg-slate-900 p-12 rounded-[3.5rem] shadow-2xl text-white">
            <h3 className="text-2xl font-black mb-8 uppercase tracking-widest text-white/40 flex items-center gap-3">
               <ShieldCheck className="text-green-400" /> Specialty Products
            </h3>
            <div className="space-y-8">
              {[
                { label: 'Irrigation Pump', price: '₹50,000', units: 'per HP', desc: 'Horticulture Special' },
                { label: 'High Mast Lighting', price: '₹20k - ₹2L', units: 'per pole', desc: 'Ind./Comm. Grade' },
                { label: 'Maintenance Visit', price: '₹1,500', units: '+ Spares', desc: 'Expert Audit' },
              ].map((item, i) => (
                <div key={i} className="flex justify-between items-center border-b border-white/10 pb-6 last:border-0">
                  <div>
                    <div className="font-black text-white text-lg">{item.label}</div>
                    <div className="text-[10px] text-white/40 font-bold uppercase tracking-widest mt-1">{item.desc}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-2xl font-black text-green-400">{item.price}</div>
                    <div className="text-[10px] text-white/40 font-bold uppercase tracking-widest">{item.units}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Finance Partners */}
      <section className="container mx-auto px-4 mb-24">
        <div className="bg-slate-50 p-12 rounded-[3rem] text-center border border-slate-100">
           <div className="inline-flex p-4 bg-white rounded-2xl mb-6 shadow-sm">
             <IndianRupee className="text-green-700" size={32} />
           </div>
           <h2 className="text-3xl font-black mb-4 uppercase tracking-tight">Financial Support</h2>
           <p className="text-slate-500 max-w-2xl mx-auto mb-8">
             We facilitate unsecured loans through SBI, Canara Bank, and other nationalized banks for PM Suryaghar installations.
           </p>
           <div className="flex flex-wrap justify-center gap-4">
             {['120 Month Repayment', 'Zero Pre-closure Charges', 'Direct Subsidy Credit', 'Minimal Paperwork'].map((f, i) => (
               <div key={i} className="flex items-center gap-2 px-6 py-3 bg-white rounded-full text-xs font-bold text-slate-700 shadow-sm border border-slate-100">
                 <CheckCircle size={14} className="text-green-600" /> {f}
               </div>
             ))}
           </div>
        </div>
      </section>
    </div>
  );
};

export default PricingPage;
